import { render, staticRenderFns } from "./DetailSurgery.vue?vue&type=template&id=4ff226c3&"
import script from "./DetailSurgery.vue?vue&type=script&lang=js&"
export * from "./DetailSurgery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports